
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/notifications",
      function () {
        return require("private-next-pages/settings/notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/notifications"])
      });
    }
  